import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../../components/common/SectionHeading';

const Section = styled.section`
  margin: 4rem 0 2rem;
`;

const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const VideoCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 1.5rem;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadows.md};
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }
`;

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

const VideoTitle = styled.h3`
  margin: 0;
  padding: 1rem 1.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.heading};
`;

const videos = [
  {
    title: '속성싸움',
    videoId: 'MdJaaao_w8A',
    url: 'https://youtu.be/MdJaaao_w8A?si=HfDex9wA2JkjEwNo',
  },
  {
    title: '제르피온전기',
    videoId: 'w5sweVt7E6s',
    url: 'https://youtu.be/w5sweVt7E6s?si=ZHa_g4ata4hi5CFj',
  },
  {
    title: '바운스볼',
    videoId: '6bAxpqBEUrM',
    url: 'https://youtu.be/6bAxpqBEUrM?si=on8c464GMnYBRoW3',
  },
];

const YoutubeSection = () => (
  <Section>
    <SectionHeading
      eyebrow="YouTube"
      title="학생 작품 영상"
      description="학생들이 만든 다양한 프로젝트를 확인해보세요."
    />
    <VideoGrid>
      {videos.map((video) => (
        <VideoCard key={video.videoId}>
          <VideoWrapper>
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.videoId}`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
            />
          </VideoWrapper>
          <VideoTitle>{video.title}</VideoTitle>
        </VideoCard>
      ))}
    </VideoGrid>
  </Section>
);

export default YoutubeSection;


